import { Config } from '@shared/configs/config';
import { ListConfig } from '@shared/modules/list/interfaces/list-config.interface';

export const ProjectTasksListConfig: ListConfig = {
  url: `${Config.API}/project/[{projectId}]/task`,
  listName: 'project-tasks',
  responseKey: ''
};
